<template>
    <div class="migrol-form__radiobutton" :class="ComputedClass">
        <input :id="$id('radio')" type="radio" :checked="shouldBeChecked" :value="radioValue" @change="updateInput" v-bind="$attrs" />
        <label :for="$id('radio')">{{label}}<slot></slot></label>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            label: {
            },
            radioValue: {
                type: [Number, String],
                required: true
            },
            value: {
                default: ''
            },
            display: {
                type: String,
                default: 'inline',
                required: false
            }
        },
        computed: {
            shouldBeChecked() {
                return this.value == this.radioValue
            },
            ComputedClass() {
                return 'migrol-form__radiobutton--' + this.display;
            },
        },
        methods: {
            updateInput() {
                this.$emit('change', this.radioValue);
            }
        }
    };
</script>